import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import BaseIcon from '../../legacy/ui/base-icon/icon.vue';

type Props = {
  text: string;
  icon?: string;
  type?: 'main' | 'alt';
  size?: 'm' | 'l';
};

export default /*@__PURE__*/_defineComponent({
  __name: 'base-promo-badge',
  props: {
    text: {},
    icon: {},
    type: { default: 'main' },
    size: { default: 'm' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([_ctx.$style.badge, _ctx.$style[__props.type], _ctx.$style[__props.size]])
  }, [
    (__props.icon)
      ? (_openBlock(), _createBlock(BaseIcon, {
          key: 0,
          type: __props.icon
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.text), 1)
  ], 2))
}
}

})